import React from 'react'
import { Form } from 'antd'
import { useTranslation } from 'lib/i18n'

import InputWithoutAutoComplete from 'components/InputWithoutAutoComplete/InputWithoutAutoComplete'
import {
  VIDEO_REQUEST_FROM_NAME,
  VIDEO_REQUEST_FROM_PRONOUN,
  VIDEO_REQUEST_IS_GIFT,
} from 'components/ProductPage/shared/FieldConstants'
import PronounOptions from 'components/ProductPage/shared/PronounOptions'

export default function VideoRequestFromName({ pronouns, theme = 'red' }) {
  const { t } = useTranslation()

  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const isGift = getFieldValue(VIDEO_REQUEST_IS_GIFT)

        if (!isGift) {
          return null
        }

        return (
          isGift && (
            <>
              <Form.Item
                name={VIDEO_REQUEST_FROM_NAME}
                label={t('FromName.fromTitle2', 'From')}
                rules={[
                  {
                    required: true,
                    message: t('FromName.fromRequired', 'Fill in your name'),
                  },
                ]}
                data-cy="fromName"
              >
                <InputWithoutAutoComplete
                  size="large"
                  placeholder={t(
                    'FromName.fromNamePlaceholder1',
                    'Name(s) of who the video is from',
                  )}
                />
              </Form.Item>
              <Form.Item shouldUpdate style={{ marginTop: 26 }}>
                {({ getFieldValue: getFieldPronounValue, setFieldsValue }) => (
                  <Form.Item name={VIDEO_REQUEST_FROM_PRONOUN}>
                    <PronounOptions
                      pronouns={pronouns}
                      onChange={setFieldsValue}
                      selected={getFieldPronounValue(
                        VIDEO_REQUEST_FROM_PRONOUN,
                      )}
                      isInverted
                      theme={theme}
                    />
                  </Form.Item>
                )}
              </Form.Item>
            </>
          )
        )
      }}
    </Form.Item>
  )
}
